var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('base-hero-simple',{staticClass:"mb-2"},[_c('base-router-links',{attrs:{"items":_vm.links}})],1),_c('rma-history-table',{staticClass:"mt-4",attrs:{"id":"rma-history-table"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }